import 'scss/solutions/non-contact-equipment.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'

(function () {
  $('.banner-buy-btn').click(function () {
    var top = $('.solutions-item-partner').offset().top - 80
    $('html,body').animate({scrollTop: Math.floor(top)}, 500)
  })
  // 应用场景
  var _sceneContext = $('.solutions-item-scene .solutions-item-context')
  var _sceneLi = $('.solutions-item-scene .solutions-item-content li')
  _sceneLi.on('click', function () {
    _sceneLi.removeClass('selected')
    $(this).addClass('selected')
    _sceneContext.html('').append(`
      <p>${$(this).data('title')}</p>
      <p>${$(this).data('desc')}</p>
      <p>${$(this).data('tech')}</p>
    `)
  })
  // 优质合作产品
  var _partnerLi = $('.solutions-item-partner .solutions-item-content li')
  var _partnerContent = $('.solutions-item-partner .solutions-item-context .content')
  var _partnerVideo = $('.solutions-item-partner .partner-video')
  var partnerHtml = ''
  _partnerLi.on('click', function () {
    _partnerLi.removeClass('selected')
    $(this).addClass('selected')
    if ($(this).data('type') === 'dct') {
      partnerHtml = `
        <p>由合作服务商——东超科技与中国科技大学第一附属医院联合推出的无接触式多功能自助终端设备。该自助机使用者不需要与屏幕接触，点击空中成像，就能完成挂号预约缴费等多功能自助服务。</p>
        <p>医院作为可能存在传染源又有大量易感人群的公众场所，就诊者、探视者、病人家属、医务工作者，各类人群密集，做好院内感染的预防尤其重要。医院的自助服务机，每天有数以千计的患者及家属触摸使用，存在交叉感染的风险。</p>
        <p>采用该技术升级后的设备区别于传统成像原理，可以无介质空中成像，摆脱成像介质的束缚，以实像的形式将画面直接呈现在空气中并可直接交互操作。使用者不需要与屏幕接触，全部操作都在空气中完成，有效降低了因人体与物体表面接触时发生交叉感染的可能性。</p>
        <div>
          <button>视频介绍</button>
          <a href="http://www.aifuwus.com/onstage/cmdpreview?id=1582" target="_blank">查看详情</a>
        </div>
      `
      document.getElementById('video-intro-non-contact').src = '//bjcdn.openstorage.cn/aicontest2019/file%2FDCT.mp4'
    } else if ($(this).data('type') === 'aiui') {
      partnerHtml = `
        <p>科大讯飞与合肥轨道合作的在合肥地铁2号线潜山路站的语音购票机。语音售票的使用方法非常简单，乘客只需对着机器说自己要去哪里，比如“我要去安徽农业大学”，语音售票机就会智能推荐你“安农大站”，乘客使用手机扫码付款即可完成购票，全程不过十几秒钟，并且不需要在机器上进行任何手动操作，避免了接触带来的交叉感染风险。</p>
        <div>
          <button>视频介绍</button>
          <a href="//aiui.iflyos.cn/index-aiui" target="_blank">查看详情</a>
        </div>
      `
      document.getElementById('video-intro-non-contact').src = '//bjcdn.openstorage.cn/aicontest2019/file%2F%E5%9C%B0%E9%93%81%E8%B4%AD%E7%A5%A8.mp4'
    } else {
      partnerHtml = `
        <p>基于科大讯飞自研人脸算法，实现核心功能。包括人脸验证及检索、人脸检测、人脸关键点定位、人脸质量评价、活体检测、眼部嘴部检测等功能，其中人脸检测、活体检测、特征识别检索全流程耗时300ms以内，高效流畅。2w底库实测，0.1%冒认率，识别准确率98%以上，准确安全。整体效果优良，无需携带任何物品即可完成身份验证，同时提供在线接口、离线SDK，可满足多种业务需求。</p>
        <div>
          <a href="/solutions/authenticate" target="_blank">查看详情</a>
          <a href="http://www.aifuwus.com/solution/index?link=stentor/notouch" target="_blank">合作咨询</a>
        </div>
      `
    }
    _partnerContent.html('').append(partnerHtml)
    bindEventVideo()
  })
  // 弹出视频控制
  var bindEventVideo = function () {
    _partnerContent.find('button').on('click', function () {
      _partnerVideo.show()
      document.getElementById('video-intro-non-contact').play()
    })
    _partnerVideo.find('.icon-close').on('click', function () {
      _partnerVideo.hide()
      document.getElementById('video-intro-non-contact').pause()
    })
  }
  bindEventVideo()
  // 特色优势
  var _adContext = $('.solutions-item-advantage .ability-advantage-content')
  var _adLi = $('.solutions-item-advantage .ability-tabs li')
  _adLi.on('click', function () {
    _adLi.removeClass('selected')
    $(this).addClass('selected')
    _adContext.html('').append(`
      <p>${$(this).data('ad1')}</p>
      <p>${$(this).data('ad2')}</p>
      <p>${$(this).data('ad3')}</p>
    `)
  })
})()



// WEBPACK FOOTER //
// ./src/js/entry/solutions/non-contact-equipment.js